import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { BsPersonWorkspace } from 'react-icons/bs';
import SlidingDiv from '../../../components/slidingDiv';
import { FaSearch } from 'react-icons/fa';
import { rootUrl } from '../../../helpers';

export default function Sellers() {
  const [searchQuery, setSearchQuery] = useState('');
  const [searchTrigger, setSearchTrigger] = useState(false);

  const [sellers, setSellers] = useState([]);
  const [newSeller, setNewSeller] = useState({ name: '', email: '', phone: '', address: '' });
  const [showForm, setShowForm] = useState(false);
  const [selectedSeller, setSelectedSeller] = useState(null);
  const [mineral, setMineral] = useState({
    seller_id: '',
    type: 'Gold', 
    gold_type: '', 
    processing_type: '',
    weight_in_grams: '',
  });

  const [isSlidingDivVisible, setIsSlidingDivVisible] = useState(false);

  const toggleSlidingDiv = () => {
    setIsSlidingDivVisible(!isSlidingDivVisible);
  };

  const searchSellers = async () => {
    try {
      const response = await axios.get(rootUrl(`/search-sellers/${searchQuery}`));
      setSellers(response.data.data);
      setSearchTrigger(true)
    } catch (error) {
      console.error(error);
    }
  };

  const addSeller = async () => {
    try {
      const response = await axios.post(rootUrl('/add-seller'), newSeller);
      toast.success(response.data.message);
      setNewSeller({ name: '', email: '', phone: '', address: '' });
    } catch (error) {
      console.error(error);
    }
  };

  const addMineral = async () => {
    try {
      const response = await axios.post(rootUrl('/add-mineral'), mineral);
      
      if(response.data.status === 200){
        setMineral({ seller_id: '', type: 'Gold', processing_type: '', weight_in_grams: '', gold_type:'' });
        toggleSlidingDiv()
        toast.success("Successful")
      }else{
        toast.error(response.data.message);
      }
      
    } catch (error) {
      console.error(error);
    }
  };

  const handleSellerClick = (seller) => {
    setSelectedSeller(seller);
    setIsSlidingDivVisible(true)
    setMineral({ ...mineral, seller_id: seller.id });
  };

  const zaddSeller = () => {
    setIsSlidingDivVisible(true)
    setShowForm(true)
  }

  return (
    <div className='p-4 shadow-lg rounded'>
      <div className="flex justify-between">
        <span className='flex items-center font-bold text-lg'> <BsPersonWorkspace/> WorkSpace</span>
        <button onClick={zaddSeller} className="bg-green-500 text-white px-4 py-2 rounded-lg">
          Add Seller
        </button>
      </div>

      <hr className='my-2' />

    <div className='flex justify-center'>

    <input
          type="text"
          placeholder="Search sellers..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="border border-green-800 p-2 rounded-lg"
        />
        <button onClick={searchSellers} className="bg-blue-500 text-white px-4 py-2 ml-2 rounded-lg">
          <FaSearch/>
        </button>

    </div>
      


        <SlidingDiv
        isVisible={isSlidingDivVisible}
        onClose={toggleSlidingDiv}
        width="w-1/3"
        backgroundColor="bg-white" 
        textColor="text-vlack"
      >
            {showForm && (
        <div className="mt-4">
          <h2 className="text-lg font-bold">Add New Seller</h2>
          <input
            type="text"
            placeholder="Name"
            value={newSeller.name}
            onChange={(e) => setNewSeller({ ...newSeller, name: e.target.value })}
            className="border p-2 rounded w-full mb-2"
          />
          <input
            type="email"
            placeholder="Email"
            value={newSeller.email}
            onChange={(e) => setNewSeller({ ...newSeller, email: e.target.value })}
            className="border p-2 rounded w-full mb-2"
          />
          <input
            type="text"
            placeholder="Phone"
            value={newSeller.phone}
            onChange={(e) => setNewSeller({ ...newSeller, phone: e.target.value })}
            className="border p-2 rounded w-full mb-2"
          />
          <input
            type="text"
            placeholder="Address"
            value={newSeller.address}
            onChange={(e) => setNewSeller({ ...newSeller, address: e.target.value })}
            className="border p-2 rounded w-full mb-2"
          />
          <button onClick={addSeller} className="bg-green-500 text-white px-4 py-2 rounded">
            Save Seller
          </button>
        </div>
      )}
      </SlidingDiv>


  

      {
      searchTrigger && (
      sellers.length > 0 ?(
        <div className="mt-4">
          <h2 className="text-lg font-bold">Search Results</h2>
          <ul>
            {sellers.map((seller) => (
              <li
                key={seller.id}
                className="border p-2 rounded my-2 cursor-pointer hover:bg-gray-100"
                onClick={() => handleSellerClick(seller)}
              >
                {seller.name} ({seller.email})
              </li>
            ))}
          </ul>
        </div>
      ):(
        "No seller with those details"
      )
    )
    }

<SlidingDiv
        isVisible={isSlidingDivVisible}
        onClose={toggleSlidingDiv}
        width="w-1/3"
        backgroundColor="bg-white" 
        textColor="text-vlack"
      >
      {selectedSeller && (
        <div className="mt-4">
          <h2 className="text-lg font-bold">Add Gold for {selectedSeller.name}</h2>
          <select
        value={mineral.gold_type}
        onChange={(e) => setMineral({ ...mineral, gold_type: e.target.value })}
        className="border p-2 rounded w-full mb-2"
      >
        <option value="">
          Select Type
        </option>
        <option value="Reef">Reef</option>
        <option value="Aluvion">Aluvion</option>
      </select>

      {/* Show Processing Type field if "Reef" is selected */}
      {mineral.gold_type === "Reef" && (
        <input
          type="text"
          placeholder="Processing Type"
          value={mineral.processing_type}
          onChange={(e) =>
            setMineral({ ...mineral, processing_type: e.target.value })
          }
          className="border p-2 rounded w-full mb-2"
        />
      )}

      {/* Common field for both types */}
      <input
        type="number"
        placeholder="Weight (in grams)"
        value={mineral.weight_in_grams}
        onChange={(e) =>
          setMineral({ ...mineral, weight_in_grams: e.target.value })
        }
        className="border p-2 rounded w-full mb-2"
      />
          <button onClick={addMineral} className="bg-green-500 text-white px-4 py-2 rounded">
            Save Mineral
          </button>
          
        </div>
      )
      }
      </SlidingDiv>
    </div>
  );
}
